import { Injectable, Injector } from '@angular/core';
import { Http, RequestOptions, URLSearchParams, Headers, Response } from '@angular/http';

import { CommonRequestService } from './common-request.service';
import { UserService } from './user.service';

import { AppSettings } from './../app.settings';

@Injectable()
export class CommonRequestTableService {

	constructor(
		private requestService: CommonRequestService,
		private userService: UserService
	) {
	}

	tableGet(gfo, paging?, successCallback?, errorCallback?) {
		const params: URLSearchParams = new URLSearchParams();
		const options: RequestOptions = new RequestOptions();
		// default paging
		paging = paging ? paging : {};
		const pageNumber: number = paging.pageNum ? paging.pageNum : 1;
		const pageSize: number = paging.pageSize ? paging.pageSize : 20;
		const rowCount: number = paging.rowCount ? paging.rowCount : 0;
		params.set('gfo', JSON.stringify(gfo));
		params.set('pageNumber', pageNumber.toString());
		params.set('pageSize', pageSize.toString());
		params.set('rowCount', rowCount.toString());
		options.params = params;
		return this.requestService.requestGet(AppSettings.serviceRootUrl + 'common/table', options, successCallback, errorCallback);
	}
	tablePost() {

	}
	tablePut(gto, sessionType, description?, successCallback?, errorCallback?) {
		const url = AppSettings.serviceRootUrl + 'common/table';
		const body = {
			application: AppSettings.appName,
			userId: this.userService.getUserInfo().userId,
			gto: JSON.stringify(gto),
			sessionType: sessionType,
			sessionDescription: description ? description : 'description'
		};
		this.requestService.requestPut(url, body, successCallback, errorCallback);
	}
}



// WEBPACK FOOTER //
// ./src/app/common-services/common-table-request.service.ts